import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import { PRODUCTS as SEED_PRODUCTS } from "@/data/mockData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext(null);

// Normalise a product doc coming from API (collection_slug) or seed (collection)
function normalise(p) {
  return { ...p, collection: p.collection_slug || p.collection };
}

export function ProductsProvider({ children }) {
  const [products, setProducts] = useState(SEED_PRODUCTS);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/products`);
      if (Array.isArray(data) && data.length) setProducts(data.map(normalise));
    } catch { /* keep seed */ }
    finally { setLoaded(true); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = useMemo(() => ({ products, loaded, reload: load }), [products, loaded, load]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useProducts() {
  const c = useContext(Ctx);
  if (!c) throw new Error("useProducts outside ProductsProvider");
  return c;
}
